// HomePage
import Blank from "./Screens/Blank.js";
import Home from "./Screens/Home/Main.js";

// Admin
import PartnerAdmin from "./Screens/Admin/Main.js";
import UserAdmin from "./Screens/Admin/Main.js";

// Partner related
import PartnerHome from "./Screens/Partner/Main.js";
import PartnerRegistration from "./Screens/Partner/Register.js";
import QuemSomos from "./Screens/QuemSomos/Main.js";
import Blog from "./Screens/Blog/Main.js";
import BlogView from "./Screens/Blog/View.js";
import TermsView from "./Screens/Terms/Main.js";

import AdminUserProfile from "./Screens/Admin/UserProfile.js";
import AdminCompanyProfile from "./Screens/Admin/CompanyProfile.js";

import AdminDashboard from "./Screens/Admin/Dashboard.js";
import AdminDocuments from "./Screens/Admin/Documents.js";
import AdminCreditcards from "./Screens/Admin/Creditcards.js";
import AdminUsers from "./Screens/Admin/Users.js";

import AdminLeads from "./Screens/Admin/Leads.js";
import AdminPayments from "./Screens/Admin/Payments.js";

import ComingSoon from "./Screens/ComingSoon.js";


var dashRoutes = [
  {
    path: "/",
    name: "Início",
    component: Home
  },  
  {
    path: "/parceiros",
    name: "Parceiros",
    component: PartnerHome
  },
  {
    path: "/parceiros/cadastro",
    name: "Cadastro de Parceiro",
    component: PartnerRegistration
  },
  {
    path: "/quem-somos",
    name: "Quem somos",
    component: QuemSomos
  },
  {
    path: "/noticias",
    name: "Notícias",
    component: Blog
  },  
  {
    path: "/noticias/:slugId",
    name: "Notícia",
    component: BlogView
  },
  {
    path: "/termos",
    name: "Termos de uso, Política de Privacidade e Preferências de Cookies",
    component: TermsView
  },   
  {
    path: "/termos/:tab",
    name: "Termos de uso, Política de Privacidade e Preferências de Cookies",
    component: TermsView
  },           
  { 
    path: "/admin",
    name: "Dashboard",
    component: AdminDashboard,
    secured:true
  },
  { 
    path: "/admin/dashboard",
    name: "Dashboard",
    component: AdminDashboard,
    secured:true
  },  
  { 
    path: "/admin/documents",
    name: "Documentos",
    component: AdminDocuments,
    secured:true
  },  
  { 
    path: "/admin/creditcards",
    name: "Cartões de crédito",
    component: AdminCreditcards,
    secured:true
  },  
  { 
    path: "/admin/userProfile",
    name: "Perfil do usuário",
    component: AdminUserProfile,
    secured:true
  },
  { 
    path: "/admin/companyProfile",
    name: "Cadastro da Empresa",
    component: AdminCompanyProfile,
    secured:true
  },
  { 
    path: "/admin/users",
    name: "Usuários",
    component: ComingSoon,
    secured:true
  },    
  { 
    path: "/admin/leads",
    name: "Direcionamentos",
    component: AdminLeads,
    secured:true
  },    
{ 
    path: "/admin/payments",
    name: "Faturas e Pagamentos",
    component: ComingSoon,
    secured:true
  }  
];
export default dashRoutes;
